import SvgPhone from '@hc-frontend/core-icons/kit/phone';

export default function ReconnectionDisclaimer({
  formattedPhoneNumber,
}: {
  formattedPhoneNumber: string;
}) {
  return (
    <div>
      <div className={`flex items-center gap-4-4 mt-2-2`}>
        <SvgPhone className={`w-[22px] h-[22px]`} />
        Call me at <span className={`font-bold`}>{formattedPhoneNumber}</span>
      </div>
      <div className={`mt-12-12 text-[rgba(0, 0, 0, 0.35)]`}>
        By clicking one of the buttons above, you represent that you are at
        least 18 years old and provide your express written consent to be
        contacted by HealthCare, Inc. and/or its partner companies and any of
        their comercial partners at the phone number you provided (including any
        wireless number) regarding various insurance products through the use of
        automated telephone dialing systems, pre-recorded messages, and/or text
        messages. Message and data rates may apply. Your consent is not a
        condition of purchase. This program is subject to our Privacy Policy and
        Terms of use.
      </div>
    </div>
  );
}
